import React, {
    useState,
    useEffect,
} from "react"
import SuggestionBoard from "./SuggestionBoard.jsx"

const NewsBoard = ({ board }) => {
    return (
        <SuggestionBoard
            title="News"
            name="News"
            board={board}
            sort_="Date"
        />
    )
}

export default NewsBoard
